import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'
import rocketIcon from 'shared/assets/icons/rocket.svg'

import type { PlatformHeroCmsContent } from 'core/services/cms/interfaces'

import bgLarge from './assets/bg-large.jpg'
import bgMd from './assets/bg-md.jpg'
import bgXsm from './assets/bg-xsm.jpg'

interface HeroProps {
  content: PlatformHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  return (
    <HeroRedesign
      imageDesktop={bgLarge}
      imageTablet={bgMd}
      imageMobile={bgXsm}
      pillText={content.pillText}
      pillIcon={rocketIcon}
      titleText={content.titleText}
      description={content.description}
    />
  )
}
